import { render, staticRenderFns } from "./new-app-version.vue?vue&type=template&id=59cd26fc"
import script from "./new-app-version.vue?vue&type=script&lang=js"
export * from "./new-app-version.vue?vue&type=script&lang=js"
import style0 from "./new-app-version.vue?vue&type=style&index=0&id=59cd26fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports